module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tobus"
  }, [_c('div', [_c('ul', [_c('li', [_c('label', [_vm._v("Target: ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.target),
      expression: "target"
    }],
    attrs: {
      "placeholder": "'foo' or 'bar'"
    },
    domProps: {
      "value": _vm._s(_vm.target)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.sendToBus()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.target = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_c('label', [_vm._v("Payload: ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payload),
      expression: "payload"
    }],
    attrs: {
      "placeholder": "Anything you want"
    },
    domProps: {
      "value": _vm._s(_vm.payload)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.sendToBus()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payload = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', [_c('div', [_c('button', {
    on: {
      "click": function($event) {
        _vm.sendToBus()
      }
    }
  }, [_vm._v("Send")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-18f126b6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sendToBusComponent.vue
// module id = 79
// module chunks = 1